'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SwapDataProvider } from "../../../../context/swap";
import { useEffect, useMemo, useRef } from "react";
import { NetworkExchangeTabs, Tabs, TabsContent, useTabs } from "./Tabs";
import NetworkForm from "./NetworkForm";
import ExchangeForm from "./ExchangeForm";
import DepositAddressForm from "./DepositAddressForm";
import FormWrapper from "./FormWrapper";
import { Widget } from "../../../../components/Widget/Index";
import { ValidationProvider } from "../../../../context/validationContext";
import { useInitialSettings } from "../../../../context/settings";
import { useSettingsState } from "../../../../context/settings";
import LayerSwapApiClient from "../../../../lib/apiClients/layerSwapApiClient";
import useSWR from "swr";
import AppSettings from "../../../../lib/AppSettings";
import clsx from "clsx";
import { useCallbacks } from "../../../../context/callbackProvider";
export default function Form() {
    const { from, appName, defaultTab: defaultTabQueryParam, theme: themeName } = useInitialSettings();
    const { sourceExchanges } = useSettingsState();
    const defaultTab = useMemo(() => {
        return defaultTabResolver({ from, sourceExchanges, defaultTabQueryParam });
    }, [from, sourceExchanges]);
    const layerswapApiClient = new LayerSwapApiClient();
    const { data: partnerData } = useSWR(appName && `/internal/apps?name=${appName}`, layerswapApiClient.fetcher);
    const partner = appName && partnerData?.data?.client_id?.toLowerCase() === appName?.toLowerCase() ? partnerData?.data : undefined;
    return _jsxs(Tabs, { defaultValue: defaultTab, children: [_jsxs("div", { className: clsx("hidden sm:block", { 'sm:hidden': AppSettings.ThemeData?.enableWideVersion !== true }), children: [_jsx(SwapPathTabSync, {}), _jsx(NetworkExchangeTabs, {})] }), _jsx(TabsContent, { value: "cross-chain", children: _jsx(SwapDataProvider, { children: _jsx(FormWrapper, { type: "cross-chain", partner: partner, children: _jsx(Widget, { contextualMenu: _jsx("div", { className: clsx("block w-full", { 'sm:hidden': AppSettings.ThemeData?.enableWideVersion == true }), children: _jsx(NetworkExchangeTabs, {}) }), children: _jsx(ValidationProvider, { children: _jsx(NetworkForm, { partner: partner }) }) }) }) }) }), _jsx(TabsContent, { value: "exchange", children: _jsx(SwapDataProvider, { children: _jsx(FormWrapper, { type: "exchange", partner: partner, children: _jsx(Widget, { contextualMenu: _jsx("div", { className: clsx("block w-full", { 'sm:hidden': AppSettings.ThemeData?.enableWideVersion == true }), children: _jsx(NetworkExchangeTabs, {}) }), children: _jsx(ValidationProvider, { children: _jsx(ExchangeForm, { partner: partner }) }) }) }) }) }), _jsx(TabsContent, { value: "deposit-address", children: _jsx(SwapDataProvider, { children: _jsx(FormWrapper, { type: "deposit-address", partner: partner, children: _jsx(Widget, { contextualMenu: _jsx("div", { className: clsx("block w-full", { 'sm:hidden': AppSettings.ThemeData?.enableWideVersion == true }), children: _jsx(NetworkExchangeTabs, {}) }), children: _jsx(ValidationProvider, { children: _jsx(DepositAddressForm, { partner: partner }) }) }) }) }) })] });
}
// The deposit-address flow writes /swap/{id} into the URL (shallow pushState)
// when it auto-creates a swap. Each tab has its own SwapDataProvider, so on tab
// switch that provider's swapId is gone but the URL path lingers. Clear it on
// every tab change. Scoped to tab changes (not unmount) so it never races with
// real page navigation.
const SwapPathTabSync = () => {
    const { activeId } = useTabs();
    const { onSwapModalStateChange } = useCallbacks();
    const prevActiveId = useRef(activeId);
    useEffect(() => {
        if (prevActiveId.current === activeId)
            return;
        prevActiveId.current = activeId;
        onSwapModalStateChange(false);
    }, [activeId]);
    return null;
};
const defaultTabResolver = ({ from, sourceExchanges, defaultTabQueryParam }) => {
    if (defaultTabQueryParam) {
        if (defaultTabQueryParam === "swap") {
            return "cross-chain";
        }
        if (defaultTabQueryParam === "cex") {
            return "exchange";
        }
        if (defaultTabQueryParam === "deposit") {
            return "deposit-address";
        }
    }
    if (from) {
        const isCex = sourceExchanges.some(exchange => exchange.name === from);
        if (isCex) {
            return "exchange";
        }
    }
    return "cross-chain";
};
